import { CanActivateFn } from '@angular/router';
import { appInjector } from 'src/app/app-injector';
import { TenancyService } from '@core/services/common';

export const RedirectToTenantGuard: CanActivateFn = () => {

  const tenancyService = appInjector().get(TenancyService);
  const basePath = tenancyService.basePath.substring(1);

  const search = window.location.search.length > 0 ? window.location.search : '';
  window.location.href = window.location.origin + `/${basePath}${window.location.pathname}${search}`;

  return false;
};
